<template>
  <div class="main-board">
    <div class="fixed">
      <div class="open" @click="mainBoardToggle">
        {{ $t('mainboard.open') }}
      </div>
      <div class="close" @click="mainBoardToggle">
        {{ $t('common.close') }}
      </div>
      <!-- 데이터 없을때(Class) : none -->
      <div class="board notice" :class="!noticeList.length ? 'none' : '' ">
        <div class="header">
          <h4 class="title">
            {{ $t('mainboard.notice') }}
          </h4>
          <div class="more" @click="moveMenu('CS001')">
            {{ $t('mainboard.more') }}
          </div>
        </div>
        <div class="body">
          <ul class="list">
            <!-- 버전(Class) : version / 이벤트(Class) : event / 확인중(Class) : checking -->
            <li v-for="notice in noticeList" :key="notice.notice_id" :class="noticeClass(notice.notice_type)" @click="moveMenu(`CS002?notice_id=${notice.notice_id}`)">
              <div class="title">
                <div class="label">
                  <div class="item">
                    {{ getNoticeType(notice.notice_type) }}
                  </div>
                </div>
                <div class="content">
                  {{ notice.title }}
                </div>
              </div>
              <div class="date">
                {{ notice.isrt_dt.substring(0,10) }}
              </div>
            </li>
          </ul>
          <div class="none">
            {{ $t('mainboard.noNotice') }}
          </div>
        </div>
      </div>
      <!-- 데이터 없을때(Class) : none -->
      <div class="board question" :class="!inquireList.length ? 'none' : '' ">
        <div class="header">
          <h4 class="title">
            {{ $t('mainboard.inquiry') }}
          </h4>
          <div class="more" @click="moveMenu('CS101')">
            {{ $t('mainboard.more') }}
          </div>
        </div>
        <div class="body">
          <ul class="list">
            <!-- 버전(Class) : version / 이벤트(Class) : event / 확인중(Class) : checking -->
            <li v-for="inquire in inquireList" :key="inquire.inquire_id" :class="inquire.status === 'completed' ? 'event' : 'checking'" @click="moveMenu(`CS102?inquire_id=${inquire.inquire_id}`)">
              <div class="title">
                <div class="label">
                  <div class="item">
                    {{ inquire.status === 'completed' ? $t('mainboard.answered') : $t('mainboard.checking') }}
                  </div>
                </div>
                <div class="content">
                  {{ inquire.title }}
                </div>
              </div>
              <div class="date">
                {{ inquire.isrt_dt.substring(0,10) }}
              </div>
            </li>
          </ul>
          <div class="none">
            {{ $t('mainboard.noInquiry') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {aplManagerService, csService} from '../../router'

export default {
  name: 'mainBoardPopup',
  data () {
    return {
      inquireList: [],
      noticeList: [],
      noticeTypeList: [
        {
          key: 'Checking',
          value: 'mainboard.checking'
        },
        {
          key: 'Event',
          value: 'mainboard.event'
        },
        {
          key: 'Version',
          value: 'mainboard.version'
        }
      ]
    }
  },
  created: function () {
    this.setData()
  },
  mounted: function () {
    if (localStorage.getItem('mainBoard') === 'open') {
      document.querySelector('.type-content').classList.remove('mainBoardInactive')
    } else if (localStorage.getItem('mainBoard') === 'close' || !localStorage.getItem('mainBoard')) {
      document.querySelector('.type-content').classList.add('mainBoardInactive')
    }
  },
  methods: {
    mainBoardToggle: function () {
      if (document.querySelector('.type-content.mainBoardInactive') == null) {
        document.querySelector('.type-content').classList.add('mainBoardInactive')
        localStorage.setItem('mainBoard', 'close')
      } else {
        document.querySelector('.type-content.mainBoardInactive').classList.remove('mainBoardInactive')
        localStorage.setItem('mainBoard', 'open')
      }
    },
    setData: function () {
      Promise.all([csService.getInquireList(1, 3), aplManagerService.getCustomerNoticeListView(1, 3)]).then(response => {
        this.inquireList = response[0].data.inquireList
        this.noticeList = response[1].data.noticeList
      })
    },
    getNoticeType: function (type) {
      if (this.noticeTypeList.find(it => it.key === type) !== undefined) {
        return this.$t(this.noticeTypeList.find(it => it.key === type).value)
      } else {
        return ''
      }
    },
    noticeClass: function (type) {
      return type.toLowerCase()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popup/MainBoard.vue